import React, { lazy, Suspense } from "react";
import LoadingInterstitial from "../LoadingInterstitial";

const ResultsRestoredMain = lazy(
  () =>
    import(/* webpackChunkName: "results-restored" */ "./ResultsRestoredMain")
);

const ResultsRestored = () => {
  return (
    <Suspense>
      <LoadingInterstitial />
      <ResultsRestoredMain />
    </Suspense>
  );
};

export default ResultsRestored;
